import { render, staticRenderFns } from "./baixapagamentos.vue?vue&type=template&id=04d2f403&"
import script from "./baixapagamentos.vue?vue&type=script&lang=js&"
export * from "./baixapagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports